import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { DotPulseComponent } from '../../../../../../../../../../../../shared/components/dot-pulse/dot-pulse.component';
import { TimeFormatPipe } from '../../../../../../../../../../../../shared/pipes/time-format.pipe';
import { MmrService } from '../../../../../../../../../../services/mmr.service';
import { ClaimDetailsPanelViewClaim } from '../../../../../../../../../../types/mmr-claims.type';

@Component({
  selector: 'app-engineer-visit',
  imports: [TimeFormatPipe, DatePipe, DotPulseComponent],
  templateUrl: './engineer-visit.component.html',
  styleUrl: './engineer-visit.component.scss',
})
export class EngineerVisitComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    const { claims } = this.mmrService.planClaimsDetails;

    const claim = claims.value()?.[this.claimType()] as ClaimDetailsPanelViewClaim;
    const currentStep = claim?.claimTracker.find((step) => step?.currentStep);

    return {
      isToday: currentStep?.meta?.appointment?.isToday,
      startTime: currentStep?.meta?.appointment?.startTime,
      endTime: currentStep?.meta?.appointment?.endTime,
      appointmentDate: currentStep?.meta?.appointment.date,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(private readonly mmrService: MmrService) {}
}
